interface MetricCardProps {
    icon: string;
    title: string;
    value: string;
    change?: number;
}

export const MetricCard = ({ icon, title, value, change }: MetricCardProps) => {
    const isPositive = change !== undefined && change >= 0;
    const isNegative = change !== undefined && change < 0;

    return (
        <div className="metric-card">
            <div className="metric-card__header">
                <img src={icon} alt={title} className="metric-card__icon" />
                <span className="metric-card__title">{title}</span>
            </div>
            <div className="metric-card__content">
                <h3>{value}</h3>
                {change !== undefined && (
                    <span
                        className={`metric-card__change ${isPositive ? 'metric-card__change--positive' : ''} ${
                            isNegative ? 'metric-card__change--negative' : ''
                        }`}
                    >
                        {Math.abs(change)}% {isPositive ? '↗' : '↘'}
                    </span>
                )}
            </div>
        </div>
    );
};
